module.exports = __webpack_public_path__ + "img/41_24.60b44118.png";